export const SENTRY_URL = window._env_.REACT_APP_SENTRY_URL || process.env.REACT_APP_SENTRY_URL;
